import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IconModule } from '../icon/icon.module';

import { StatusFieldComponent } from './status-field.component';


@NgModule({
  imports: [
    CommonModule,
    IconModule,
  ],
  declarations: [
    StatusFieldComponent,
  ],
  exports: [
    StatusFieldComponent,
  ],
  providers: []
})
export class StatusFieldModule {}
